import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {H1, H2, H3, H4, H5} from '../Common/Titles';


const titleComponents = {
  H1,
  H2,
  H3,
  H4,
  H5,
};

const HTitle = ({level, ...props}) => {
  const levelNumber = Math.floor(level);
  let title = 'H1';

  if (levelNumber > 0 && levelNumber < 6)
    title = `H${levelNumber}`;

  let TitleComponent = titleComponents[title];

  return <TitleComponent {...props}/>;
};

export default memo(HTitle);

HTitle.propTypes = {
  level: PropTypes.string
};
